module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_vm._v(_vm._s(_vm.invoice.loadDate))]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [(_vm.invoice.containerCode != '') ? _c('div', [_vm._v("\n            P. " + _vm._s(_vm.invoice.containerCode) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4",
      "align": "left"
    }
  }, [_vm._v(_vm._s(_vm.invoice.description))]), _vm._v(" "), (_vm.invoice.receivableRemainingIdr !== 0) ? _c('Col', {
    attrs: {
      "span": "3",
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.invoice.receivableRemaining)) + " (" + _vm._s(_vm._f("numberFormatted")(_vm.invoice.receivableRemainingIdr)) + ")")]) : _c('Col', {
    attrs: {
      "span": "3",
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("numberFormatted")(_vm.invoice.receivableRemaining)))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1b5824a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/cInvoiceUnSettledByMarkingRow.vue
// module id = 1846
// module chunks = 1